export default __webpack_public_path__ + "static/media/chevron-white.63df8668.svg";